import { render, staticRenderFns } from "./vehicle-types-dropdown.vue?vue&type=template&id=b00a2e4a&scoped=true&"
import script from "./vehicle-types-dropdown.vue?vue&type=script&lang=js&"
export * from "./vehicle-types-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00a2e4a",
  null
  
)

export default component.exports